// Uitgebreide teksten per dienst — basis voor de subdienst-pagina's.
export interface DienstContent {
  /** Korte intro onder de H1. */
  intro: string;
  /** Body-paragrafen. */
  paragraphs: string[];
  /** Meta description voor de subpagina. */
  metaDescription: string;
  /** Kernpunten in de zijkolom. */
  highlights: string[];
}

export const dienstContent: Record<string, DienstContent> = {
  dakkapel: {
    intro:
      "Wij maken binnen 3 dagen een dakkapel op maat. Hierdoor sluit de dakkapel perfect aan op je dak en je verwachtingen.",
    paragraphs: [
      "Omdat we de dakkapel ter plekke op maat maken, kan het precies worden wat je in gedachten had — zonder de limitaties van een kant-en-klaar model. Je hebt volledige controle over het materiaal en de afwerking.",
      "Met een dakkapel maak je van een donkere zolder een heerlijk ruime kamer vol daglicht. Zo kun je er bijvoorbeeld een slaapkamer van maken, een hobbykamer of een kantoor. De mogelijkheden zijn eindeloos.",
      "Dat maakt het misschien moeilijk om iets te kiezen, maar wij helpen je graag met het maken van een plan.",
    ],
    metaDescription:
      "Dakkapel op maat in Dordrecht — binnen 3 dagen geplaatst door Fedor Timmerwerken. Vrije keuze in materiaal en afwerking.",
    highlights: [
      "Binnen 3 dagen geplaatst",
      "Ter plekke op maat gemaakt",
      "Vrije keuze in materiaal en afwerking",
    ],
  },
  aanbouw: {
    intro:
      "Om meer ruimte te hebben, heb je geen nieuw huis nodig. Breid je woonkamer uit, voeg een serre toe, verplaats de keuken of creëer een hele nieuwe kamer.",
    paragraphs: [
      "Wanneer je behoefte hebt aan extra ruimte maar nog steeds gek bent op je huis — of simpelweg geen zin hebt om te verhuizen — kan een aanbouw de uitkomst zijn. Een fijne bijkomstigheid: het is vaak sneller en goedkoper dan verhuizen.",
      "Het toevoegen van woonoppervlak is een investering in de waarde van je huis, maar ook in je wooncomfort. Daarbij kan een aanbouw goed geïsoleerd worden, waardoor je mogelijk zelfs bespaart op je energiekosten.",
    ],
    metaDescription:
      "Aanbouw laten bouwen in Dordrecht? Fedor Timmerwerken breidt je woonkamer, keuken of serre uit — goed geïsoleerd en op maat.",
    highlights: ["Sneller en goedkoper dan verhuizen", "Goed geïsoleerd", "Meer woningwaarde"],
  },
  renovatie: {
    intro:
      "Ben je toe aan verandering? Haal het meeste uit je woning door deze om te bouwen tot je droomhuis. Bepaal zelf de indeling — alles is mogelijk.",
    paragraphs: [
      "We helpen je graag om van je huis een thuis te maken. Jij bedenkt het, wij bouwen het.",
      "Wil je je huis moderniseren? Bij het uitvoeren van werkzaamheden die de woning verduurzamen kom je mogelijk in aanmerking voor subsidie.",
    ],
    metaDescription:
      "Complete renovatie van je woning in Dordrecht. Fedor Timmerwerken verbouwt je huis tot je droomhuis — inclusief verduurzaming en subsidieproof offertes.",
    highlights: ["Zelf de indeling bepalen", "Mogelijk subsidie bij verduurzaming", "Eén aanspreekpunt"],
  },
  "dakkapel-renovatie": {
    intro:
      "Een bestaande dakkapel renoveren is vaak goedkoper en sneller dan de dakkapel geheel vervangen. Wij bespreken graag alle mogelijkheden.",
    paragraphs: [
      "Na een renovatie ziet de dakkapel er niet alleen weer mooi uit — we kunnen de dakkapel gelijk voorzien van hoogwaardige isolatie. Door de bestaande dakkapel te combineren met nieuwe materialen en technieken, is deze binnenkort nog beter dan nieuw.",
      "Het isoleren van de dakkapel bespaart stookkosten en is dus ook nog eens goed voor het milieu. Indien gewenst is het ook de perfecte gelegenheid om de rest van het dak mee te nemen.",
      "Bij het uitvoeren van werkzaamheden die de woning verduurzamen kom je mogelijk in aanmerking voor subsidie.",
    ],
    metaDescription:
      "Dakkapel renoveren in Dordrecht — sneller en goedkoper dan vervangen, direct voorzien van hoogwaardige isolatie. Fedor Timmerwerken bespreekt de mogelijkheden.",
    highlights: ["Goedkoper dan vervangen", "Hoogwaardige isolatie", "Mogelijk subsidie"],
  },
  vlonder: {
    intro:
      "Door een vlonder toe te voegen aan het huis creëer je een karaktervolle overgang van huis naar tuin.",
    paragraphs: [
      "Loop van buiten naar binnen zonder zand mee te nemen en breng je favoriete stoel eenvoudig naar buiten.",
      "We bouwen de vlonder om je huis heen, aan de hand van jouw wensen. Hierdoor is het vrijwel altijd mogelijk om een vlonder te plaatsen.",
    ],
    metaDescription:
      "Houten vlonder op maat in Dordrecht. Fedor Timmerwerken bouwt de vlonder om je huis heen, volledig naar jouw wensen. Vraag een vrijblijvende offerte aan.",
    highlights: ["Op maat om je huis heen", "Vrijwel altijd mogelijk", "Naadloze overgang naar de tuin"],
  },
  schuur: {
    intro:
      "Met een schuur of overkapping op maat creëer je in de tuin de ruimte die je mist: een droge berging, een beschutte buitenplek, een werkplaats of een volwaardige tuinkamer.",
    paragraphs: [
      "We ontwerpen en bouwen schuren en overkappingen die perfect passen bij jouw woning en tuin. Of je nu kiest voor een compacte houten berging, een ruime schuur met werkbank en deuren, een terrasoverkapping om onder te zitten, of een combinatie van beiden: alles wordt op maat gemaakt.",
      "Je bepaalt zelf materiaal, dakvorm en afwerking — douglas, vuren of hardhout, met een plat dak, zadeldak of lessenaarsdak. Wil je de ruimte ook in de winter gebruiken? Dan voorzien we de schuur of overkapping van isolatie, elektra en verlichting.",
      "Wij regelen het complete traject, inclusief fundering of betonvloer. In veel gevallen mag een schuur of overkapping in de achtertuin vergunningvrij worden geplaatst. Samen bekijken we wat er op jouw perceel in de Drechtsteden mogelijk is.",
    ],
    metaDescription:
      "Schuur & overkapping op maat in Dordrecht. Berging, werkplaats, terrasoverkapping of tuinkamer — gebouwd door Fedor Timmerwerken. Vraag een vrijblijvende offerte aan.",
    highlights: ["Schuur, overkapping of combinatie", "Keuze in hout, dak en isolatie", "Vaak vergunningvrij"],
  },
  kozijnen: {
    intro:
      "Verduurzaam je huis met HR++ glas of triple glas en laat de kozijnen op maat leveren en monteren door Fedor Timmerwerken.",
    paragraphs: [
      "Wij leveren kozijnen van hout, kunststof en zelfs aluminium. Met het plaatsen van nieuwe kozijnen krijgt je huis een fris uiterlijk, bespaar je stookkosten en maak je jouw huis echt je eigen plek.",
      "Waar je ook naar op zoek bent, we staan klaar om je ermee te helpen.",
      "Bij het uitvoeren van werkzaamheden die de woning verduurzamen kom je mogelijk in aanmerking voor subsidie.",
    ],
    metaDescription:
      "Nieuwe kozijnen in Dordrecht met HR++ of triple glas — hout, kunststof of aluminium, op maat geleverd en gemonteerd door Fedor Timmerwerken. Subsidieproof.",
    highlights: ["HR++ of triple glas", "Hout, kunststof of aluminium", "Mogelijk subsidie"],
  },
  dakopbouw: {
    intro:
      "Er kan een complete verdieping worden toegevoegd aan je huis, waarbij je kunt kiezen tussen een plat dak of een puntdak.",
    paragraphs: [
      "Met een extra verdieping heb je niet alleen veel meer ruimte, maar verhoog je ook de waarde van het huis.",
    ],
    metaDescription:
      "Dakopbouw in Dordrecht — een complete extra verdieping met plat dak of puntdak, gebouwd door Fedor Timmerwerken. Meer ruimte en meer woningwaarde.",
    highlights: ["Complete extra verdieping", "Plat dak of puntdak", "Meer woningwaarde"],
  },
  specials: {
    intro:
      "Interesse in een project dat niet in de gemiddelde folder staat? Fedor Timmerwerken werkt graag mee om jouw wensen tot werkelijkheid te brengen.",
    paragraphs: [
      "Door ervaring in de interieurbouw, een passie voor ontwikkeling en het vertrouwen van klanten om hun visie uit te voeren, is Fedor Timmerwerken ervaren in het bouwen van ideeën.",
      "Of het nu een inbouwkast, een tuinhekje, een trap, een glijbaan, een radiatorombouw, een boomhuis, een hondenhuis of een bank voor in de tuin is: als jij het kunt bedenken, zorgen wij dat je het krijgt.",
    ],
    metaDescription:
      "Maatwerk timmerwerk in Dordrecht: inbouwkasten, trappen, radiatorombouw, boomhuizen en meer. Fedor Timmerwerken is ervaren in het bouwen van ideeën.",
    highlights: ["Volledig maatwerk", "Ervaring in interieurbouw", "Van inbouwkast tot boomhuis"],
  },
};
